<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label?: string
    disabled?: boolean
    feedbackCount?: number
    exchangeName?: string
    exchangeId?: string
  }>(),
  {
    disabled: false,
    feedbackCount: 0,
    exchangeName: '',
    exchangeId: '',
  },
)

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()
const { t } = useAppI18n()
const resolvedLabel = computed(() => props.label || t('83575'))
// 将接口反馈数量限制为正整数，避免异常值在按钮角标中展示。
const normalizedFeedbackCount = computed(() => Math.max(0, Math.floor(Number(props.feedbackCount) || 0)))
const formattedFeedbackCount = computed(() =>
  normalizedFeedbackCount.value > 999 ? '999+' : String(normalizedFeedbackCount.value),
)

const matomo = useMatomo()

const FeedbackIcon = 'https://resources1.interface003.com/web30/2026/06/15/efeabf62-3dd9-4ed3-a1b3-ef402f94dc94.png'

const handleClick = (event: MouseEvent) => {
  matomo.trackEvent('broker_feedback_button', {
    af_type: '反馈',
    af_name: props.exchangeId || '',
    af_code: props.exchangeName || '',
  })
  emit('click', event)
}
</script>

<template>
  <button
    type="button"
    class="write-feedback-button relative inline-flex h-[54px] shrink-0 cursor-pointer items-center justify-center gap-[8px] overflow-visible rounded-[1000px] border-0 bg-[#112d73] px-[32px] py-[16px] text-center text-[14px] leading-[22px] font-[600] whitespace-nowrap text-white shadow-[0_0_1px_0_rgba(30,31,33,0.12),0_0_8px_0_rgba(30,31,33,0.16)] transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="disabled"
    @click="handleClick"
  >
    <span class="flex !h-[20px] !w-[20px] shrink-0 items-center justify-center" aria-hidden="true">
      <CommonImage
        object-fit="contain"
        class="size-full shrink-0 brightness-0 invert"
        :src="FeedbackIcon"
        alt=""
        loading="eager"
        fetch-priority="high"
      />
    </span>
    <span class="shrink-0">{{ resolvedLabel }}</span>
    <span
      v-if="normalizedFeedbackCount > 0"
      class="absolute top-[-4px] right-[-4px] flex h-[16px] min-w-[16px] items-center justify-center rounded-[1000px] bg-[#e2483d] text-[12px] leading-[18px] font-[400] whitespace-nowrap text-white rtl:right-auto rtl:left-[-4px]"
      :class="normalizedFeedbackCount > 9 ? 'px-[5px]' : 'px-[0]'"
    >
      {{ formattedFeedbackCount }}
    </span>
  </button>
</template>

<style scoped lang="less">
.write-feedback-button {
  &:hover:not(:disabled) {
    background:
      linear-gradient(0deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%),
      var(--color-brand-default, #112d73);
  }

  &:focus-visible {
    outline: 2px solid rgba(17, 45, 115, 0.32);
    outline-offset: 2px;
  }
}
</style>
